<style lang="less" scoped>
.main-container {
  width: 100%;
  height: 100%;
  background: #eaecf3;
  .left-logo-menu-div {
    width: 329px;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-image: url("../assets/main/left-bg.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    .pro-title-div {
      margin-top: 30px;
      margin-bottom: 16px;
      .left-close-icon {
        margin-left: 30px;
        font-size: 18px;
        color: #ffffff;
        cursor: pointer;
      }
      .right-title-div {
        margin-left: 28px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
    }
    .left-settings-div {
      margin: 32px 20px;
      .user-info-div {
        margin-bottom: 16px;
        .right-title-div {
          font-size: 16px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 40px;
          margin-left: 40px;
        }
      }
      .setting-child-div {
        .left-icon-div {
          width: 40px;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .right-title-div {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 32px;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
  }
  .left-small-menu-div {
    width: 121px;
    background-image: url("../assets/main/left-small-menu-bg.png");
    .menu-collpose-div {
      margin-top: 24px;
      height: 56px;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 26px;
    }
  }
  .left-logo-menu-div::-webkit-scrollbar {
    width: 0;
  }
  .right-bar-content-div {
    overflow-y: auto;
    .action-btns-div {
      width: 100%;
      height: 64px;
      background: rgba(62, 174, 232, 1);
      border: 0;
      .user-logout-div {
        margin-right: 32px;
        cursor: pointer;
        .user-icon-div {
          margin-right: 8px;
        }
        .down-icon-div {
          margin-left: 8px;
        }
        .user-name-div {
          font-size: 14px;
          color: #fff;
        }
      }
    }
    .center-line-div {
      width: 100%;
      height: 1px;
      background: #51b8ee;
    }
    .bread-crumb-div {
      width: 100%;
      height: 64px;
      background: rgba(62, 174, 232, 1);
    }
    .content-view-div {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<template>
  <div class="main-container flex">
    <div
      :class="
        menuCollposed
          ? 'left-logo-menu-div left-small-menu-div'
          : 'left-logo-menu-div'
      "
    >
      <div
        v-if="menuCollposed"
        class="menu-collpose-div"
        @click="updateMenuCollposed"
      >
        <img
          src="../assets/main/menu-collpose.png"
          class="menu-collpose-icon"
          width="25"
        />
      </div>
      <div v-else class="pro-title-div flex">
        <div class="left-close-icon" @click="updateMenuCollposed">
          <img
            src="../assets/main/menu-left.png"
            class="menu-collpose-icon"
            width="11"
            height="17"
          />
          <!-- <i class="el-icon-close"></i> -->
        </div>
        <div class="right-title-div">桩到家充电服务平台</div>
      </div>
      <div class="menu-div flex-1">
        <Menu></Menu>
      </div>
      <div class="left-settings-div">
        <div class="user-info-div flex">
          <div class="left-user-icon-div">
            <img
              src="../assets/menu-img/user-icon.png"
              class="user-logo-icon"
              width="40"
            />
          </div>
          <div v-if="menuCollposed == false" class="right-title-div">
            {{ userName }}
          </div>
        </div>
        <!-- <div class="setting-child-div flex">
                    <div class="left-icon-div">
                        <img src="http://img.cdn.wxzhida.cn/zdj4/menu/setting.png" class="sys-setting-icon" width="20">
                    </div>
                    <div v-if="menuCollposed == false" class="right-title-div">系统设置</div>
                </div> -->
        <div class="setting-child-div flex" @click="logoutFun">
          <div class="left-icon-div">
            <img
              src="../assets/menu-img/login-out.png"
              class="sys-logout-icon"
              width="20"
            />
          </div>
          <div v-if="menuCollposed == false" class="right-title-div">
            退出系统
          </div>
        </div>
      </div>
    </div>
    <div class="right-bar-content-div flex-1">
      <!-- <div class="bread-crumb-div">
                        <bread-crumb></bread-crumb>
                    </div> -->
      <div class="content-view-div">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/menu/index.vue";
export default {
  components: {
    Menu,
  },
  data() {
    return {
      menuCollposed: false,
      userName: "",
    };
  },
  methods: {
    init() {
      this.userName = this.$store.state.userInfo.userName;
    },
    logoutFun() {
      let _ = this;
      _.$U.showLoading(_);

      _.$H
        .get(_, _.$A.logout)
        .then((res) => {

          _.$U.hideLoading(_);
          _.$store.commit("setToken", "");
          _.$router.replace("/");
        });
    },
    updateMenuCollposed() {
      this.menuCollposed = !this.menuCollposed;
      this.$store.commit("setMenuCollapse", this.menuCollposed);
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    getUserName() {
      return this.$store.state.userInfo.userName;
    },
  },
};
</script>
